/**
 * Declares this SDK's telemetry identity to the host.
 *
 * Every record would otherwise be attributed to the host SDK
 * (`spatius-web-sdk`, at the host's version), leaving RTC traffic
 * indistinguishable from a plain AvatarKit integration and this SDK's own
 * version absent from the data entirely — `sdk.package` and `sdk.version` are
 * the fields the backend splits RTC traffic by, which is why Android and iOS
 * each declare the same pair.
 *
 * **Timing.** The attribution is read when AvatarKit builds its OpenTelemetry
 * Resource and is fixed from then on, so the claim has to land before
 * `AvatarSDK.initialize()`. Running it as a module side effect ties it to the
 * import itself: importing anything from this package claims the identity, well
 * ahead of any call the host makes. Doing it in `AvatarPlayer`'s constructor
 * would be too late — a host that initializes the SDK before constructing a
 * player would already have its Resource built.
 */

import { setSdkIdentity } from '@spatius/avatarkit/internal-telemetry';

setSdkIdentity({
  sdkPackage: 'spatius-web-rtc',
  // Injected from package.json at build time, so a version bump cannot leave
  // this reporting a stale number.
  sdkVersion: __RTC_SDK_VERSION__,
});
